export const EVO_WRAPPER_MESSAGE_TYPE = 'EVO_WRAPPER_MESSAGE';
export const EVO_WRAPPER_INIT_SUBTYPE = 'EVO_WRAPPER_INIT';
export const EVO_WRAPPER_BALANCE_UPDATE_SUBTYPE = 'EVO_WRAPPER_BALANCE_UPDATE';
export const EVO_WRAPPER_TOGGLE_FULLSCREEN_SUBTYPE = 'EVO_WRAPPER_TOGGLE_FULLSCREEN';
export const EVO_WRAPPER_RECONNECT_EZUGI_WEBSOCKET_SUBTYPE = 'EVO_WRAPPER_RECONNECT_EZUGI_WEBSOCKET';
export const EVO_WRAPPER_PUSH_ANALYTICS_SUBTYPE = 'EVO_WRAPPER_PUSH_ANALYTICS';
export const EVO_WRAPPER_CONTINUE_WITHOUT_VIDEO_SUBTYPE = 'EVO_WRAPPER_CONTINUE_WITHOUT_VIDEO';
export const EVO_WRAPPER_CLEAR_DIALOG_STORE_SUBTYPE = 'EVO_WRAPPER_CLEAR_DIALOG_STORE';
export const EVO_WRAPPER_VOLUME_UPDATE_SUBTYPE = 'EVO_WRAPPER_VOLUME_UPDATE';

export const TRIGGER_UPDATE_BALANCE_SOCKET_MESSAGE = 'triggerUpdateBalance';
